import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';

const SelfCareToolTip = ({icon,text}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className='tool-tip-wrapper'
      onMouseEnter={() => {
        setVisible(true);
      }}
      onMouseLeave={() =>
        setVisible(false)}
      >
      <Image className='tool-tip-icon' src={icon} height={24} width={24} />
      {visible && (
        <>
          <div className='pointer-text-container'>
            <div className={`pointer`}> </div>
            <div className='text-wrapper'>
              <span className='text'>{text}</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SelfCareToolTip);
